import React from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import AuthLayout from "layouts/Auth.jsx";
import AdminLayout from "layouts/Admin.jsx";
import "assets/scss/material-dashboard-pro-react.scss?v=1.5.0";

const history = createBrowserHistory();

function App(){
    const token = localStorage.getItem('admin_token');
    let isAuthenticated = false;
    if(token){
        isAuthenticated = true
    }
    return (
        <Router history={history}>
            {!isAuthenticated 
                ? <Switch>
                    <Route path="/auth" exact component={() => <Redirect to="/auth/login-page" />} />
                    <Route path="/auth" component={AuthLayout} />
                    <Redirect to="/auth/login-page" />
                </Switch>
                : <Switch>
                    <Route path="/admin" exact component={() => <Redirect to="/admin/vendors" />} />
                    <Route path="/admin" component={AdminLayout} />
                    <Redirect to="/admin/vendors" />
                </Switch>
            }
        </Router>
    )
}

export default App;